import * as React from "react"

import { cn } from "@/lib/utils"

export const fcInputClass = "flex h-10 w-full rounded-lg border border-fc-stroke-2 bg-fc-well px-3 py-2 text-[13px] text-white transition-[border-color,box-shadow] duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/30 focus-visible:outline-none focus-visible:border-fc-accent/70 focus-visible:shadow-fc-focus disabled:cursor-not-allowed disabled:opacity-50"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(fcInputClass, className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
